import styled from 'styled-components';

import CardGroupStyled from '../../components/CardGroup';
import HeroStyled from '../../components/Hero';
import PaginationStyled from '../../components/Pagination';
import commonPageContentStyles from '../../styles/mixins/_commonPageContentStyles';

const dataCardGroups = [
  {
    id: 1,
    title: '1',
    content: '1',
    linkUrl: '1',
    cards: [
      {
        title: 'Buttons',
        content:
          'It defines the primary and secondary button styles, including their color palettes, typography, and size, along with corresponding hex codes or Pantone values, ensuring consistency across all user interfaces.',
        linkUrl: '/general-components/buttons',
        image: '/images/general-components/general-components-buttons@3x.jpg',
      },
      {
        title: 'Links',
        content:
          'It specifies the primary and secondary link styles, including color, hover effects, and underlining, ensuring a consistent and intuitive user experience across all digital platforms.',
        linkUrl: '/general-components/links',
        image: '/images/general-components/general-components-links@3x.jpg',
      },
      {
        title: 'Form Elements',
        content:
          'It defines the styling and behavior of form elements, such as input fields, checkboxes, radio buttons, and dropdowns, to ensure a seamless and consistent user experience throughout all forms.',
        linkUrl: '/general-components/form-elements',
        image: '/images/general-components/general-components-form-elements@3x.jpg',
      },
    ],
  },
  {
    id: 2,
    title: '1',
    content: '1',
    linkUrl: '1',
    cards: [
      {
        title: 'Communication',
        content:
          'This section outlines the design principles for communication elements, including tone, language, and visual consistency. It ensures that all messaging aligns with the brand’s identity and is clear and accessible to the intended audience.',
        linkUrl: '/general-components/communication',
        image: '/images/general-components/general-components-communication@3x.jpg',
      },
      {
        title: 'Navigation',
        content: `This section defines the design principles for navigation elements, including layout, interaction states, and positioning. It ensures a consistent and intuitive user experience, guiding users seamlessly through the interface while maintaining alignment with the brand's visual identity.`,
        linkUrl: '/general-components/navigation',
        image: '/images/general-components/general-components-navigation@3x.jpg',
      },
      {
        title: 'Selection',
        content:
          'This section provides guidelines for selection elements, including the design, interaction behaviors, and visual cues for selecting items within the interface. It ensures consistency and clarity across all selection components, enhancing user interaction while maintaining the brand’s aesthetic.',
        linkUrl: '/general-components/selection',
        image: '/images/general-components/general-components-selection@3x.jpg',
      },
    ],
  },
  {
    id: 3,
    title: '1',
    content: '1',
    linkUrl: '1',
    cards: [
      {
        title: 'Containment',
        content:
          'This section outlines containment guidelines to ensure clean, organized layouts. It includes instructions on logo usage, covering acceptable variations like full-color, monochrome, and reverse versions for consistency across all platforms.',
        linkUrl: '/general-components/containment',
        image: '/images/general-components/general-components-containment@3x.jpg',
      },
      {
        title: 'Table',
        content: `This section defines the primary and secondary color palettes, providing corresponding hex codes or Pantone values for consistency across all brand materials. It ensures that colors are used uniformly to maintain the brand's visual identity in all communications.`,
        linkUrl: '/general-components/table',
        image: '/images/general-components/general-components-table@3x.jpg',
      },
    ],
  },
];
type GeneralComponentsStructureProps = {
  className?: string;
};

const GeneralComponentsStructure = ({ className = '' }: GeneralComponentsStructureProps) => (
  <div className={className}>
    <div className="content">
      <HeroStyled
        title="General Components"
        subtitle={
          <>
            <p>
              General components serve as the building blocks of the user interface, helping create
              a cohesive and consistent experience across the platform. These elements, such as
              buttons, input fields, and navigation menus, should be designed with clarity and
              simplicity in mind to ensure users can easily interact with the interface.
            </p>
            <p>
              Outlining the visual and stylistic elements of a brand, these guidelines ensure
              consistency across all communication channels. They typically include rules for logo
              usage, color palette, typography, imagery, and overall design principles. The goal is
              to maintain brand consistency, ensure brand recognition, and foster a cohesive
              identity across all touchpoints and mediums.
            </p>
          </>
        }
        category
      />
      <div>
        {dataCardGroups.map((cardGroup) => (
          <CardGroupStyled
            key={cardGroup.id}
            title={cardGroup.title}
            content={cardGroup.content}
            linkUrl={cardGroup.linkUrl}
            cards={cardGroup.cards}
            category
          />
        ))}
      </div>
      <PaginationStyled
        previousLink="/branding-styleguide"
        previous="Branding Styleguide"
        previousDisabled="disabled"
        nextLink="/general-components/buttons"
        next="Buttons"
      />
    </div>
  </div>
);

const GeneralComponents = styled(GeneralComponentsStructure)`
  ${commonPageContentStyles}

  height: 100%;
  overflow: unset;

  .content {
    padding: 0;
  }
`;

export default GeneralComponents;
